export default {
  "common_dialog_accept": "确定",
  "common_dialog_cancel": "取消",
  "common_alert_system_busy": "系统忙碌中, 请稍后再试",
  "common_button_commit": "送出",
  "common_button_confirm": "确认",
  "common_button_complete": "完成",
  "common_loading": "读取中",
  "phone_input_country_code": "区域代码",
  "phone_input_country_error": "选择区域代码",
  "phone_input_number_hint": "手机号码",
  "phone_input_number_example": "范例",
  "title_invite_code": "输入邀请码",
  "title_active_account": "输入启动码",
  "title_login": "登入",
  "title_system_name": "楼易健康坎点预测系统",
  "title_basic_info": "基本资料",
  "title_question": "健康问卷",
  "title_report": "会员报告",
  "title_contact": "连系客服",
  "title_privacy_policy": "隐私权政策",
  "title_services": "服务条款",
  "title_edit_basic_info": "帐户设置",
  "menu_account_setting": "帐户设置",
  "menu_account_setting_basic_info": "基本资料",
  "menu_more": "更多检测",
  "menu_more_skin_test": "肤质检测",
  "menu_about_us": "关于我们",
  "menu_about_us_louyiai": "楼易健康科技官方网站",
  "menu_about_us_contact": "联系客服",
  "menu_about_us_privacy_policy": "隐私权政策",
  "menu_about_us_services": "服务条款",
  "menu_about_us_other": "其他",
  "menu_about_us_logout": "登出",
  "home_field_invite_code": "邀请码",
  "home_field_invite_code_hint": "请输入邀请码",
  "home_field_invite_code_error": "邀请码错误",
  "active_account_field_active_code": "启动码",
  "active_account_field_active_code_hint": "请输入启动码",
  "active_account_field_invite_code_error": "启动码错误",
  "concat_mail": "楼易客服邮箱",
  "concat_time": "周一至周五(例假日除外)",
  "before_start_content": "楼中亮医师团队 以中医理论及楼氏古中医为核心，\n辅助以AI人工智慧和大资料库等，\n使其数位化、生活化、定制化和普及化，\n让大众不只可以了解自身的身体状况也可以实现「算病、防病、治病」，让健康更加容易。 ",
  "before_start_button_start": "开始",
  "basic_info_field_unknow": "未知",
  "basic_info_hint": "提示",
  "basic_info_hint_content": "基本资料将会影响报告结果，请填写正确，谢谢。",
  "basic_info_field_select": "请选择",
  "basic_info_field_select_year": "年",
  "basic_info_field_select_month": "月",
  "basic_info_field_select_date": "日",
  "basic_info_field_select_tw": "民国 {0}",
  "basic_info_field_unknow": "未知",
  "basic_info_field_name": "姓名",
  "basic_info_field_name_hint": "楼小易",
  "basic_info_field_id_number": "身分证字号",
  "basic_info_field_id_number_message": "请输入身分证字号",
  "basic_info_field_id_number_error": "身分证字号验证失败",
  "basic_info_field_is_overseas": "海外人士请勾选",
  "basic_info_field_id_number_hint": "A123456789",
  "basic_info_field_id_passport": "护照号码",
  "basic_info_field_id_passport_hint": "请输入护照号码",
  "basic_info_field_gender": "性别",
  "basic_info_field_gender_0": "女",
  "basic_info_field_gender_1": "男",
  "basic_info_field_blood_type": "血型",
  "basic_info_field_blood_type_A": "A型",
  "basic_info_field_blood_type_B": "B型",
  "basic_info_field_blood_type_O": "O型",
  "basic_info_field_blood_type_AB": "AB型",
  "basic_info_field_birth_date": "出生日期",
  "basic_info_field_birth_type_solor": "阳历",
  "basic_info_field_birth_type_lunar": "阴历(农历)",
  "basic_info_field_birth_solor": "阳历生日",
  "basic_info_field_birth_lunar": "阴历生日",
  "basic_info_field_lunar_to_solor": "阴历自动转换阳历",
  "basic_info_field_solor_to_lunar": "阳历自动转换阴历",
  "basic_info_field_isleap_in_solar": "(闰)",
  "basic_info_field_isleap": "闰月",
  "basic_info_mobile": "手机号码",
  "basic_info_field_birth_hour": "出生时辰",
  "basic_info_field_birth_hour_select_0": "早子",
  "basic_info_field_birth_hour_select_1": "丑",
  "basic_info_field_birth_hour_select_3": "寅",
  "basic_info_field_birth_hour_select_5": "卯",
  "basic_info_field_birth_hour_select_7": "辰",
  "basic_info_field_birth_hour_select_9": "巳",
  "basic_info_field_birth_hour_select_11": "午",
  "basic_info_field_birth_hour_select_13": "未",
  "basic_info_field_birth_hour_select_15": "申",
  "basic_info_field_birth_hour_select_17": "酉",
  "basic_info_field_birth_hour_select_19": "戌",
  "basic_info_field_birth_hour_select_21": "亥",
  "basic_info_field_birth_hour_select_23": "夜子",
  "basic_info_field_constitution": "体质",
  "basic_info_field_constitution_C101": "阳虚",
  "basic_info_field_constitution_C103": "阴虚",
  "basic_info_field_constitution_C104": "气虚",
  "basic_info_field_constitution_C105": "湿热",
  "basic_info_field_constitution_C106": "痰湿",
  "basic_info_field_constitution_C107": "气郁",
  "basic_info_field_constitution_C109": "血瘀",
  "basic_info_field_constitution_C110": "过敏",
  "basic_info_button_next": "下一步",
  "basic_info_field_auto_creat": "将自动产生",
  "basic_info_field_name_message": "请输入姓名",
  "basic_info_field_gender_message": "请选择性别",
  "basic_info_field_gender_error": "性别与身分证选择不符",
  "basic_info_field_birth_date_message": "请选择出生日期",
  "basic_info_field_birth_hour_message": "请选择出生时辰",
  "basic_info_field_blood_type_message": "请选择血型",
  "basic_info_field_lunar_message": "请先输入阴历生日",
  "basic_info_field_solor_message": "请先输入阳历生日",
  "edit_basic_info_field_name": "姓名",
  "edit_basic_info_field_name_hint": "楼小易",
  "edit_basic_info_field_mobile": "手机号码",
  "edit_basic_info_field_token": "验证码",
  "edit_basic_info_field_token_hint": "请输入手机验证码",
  "edit_basic_info_button_token_send": "发送验证码",
  "edit_basic_info_alert_modified_success": "修改成功",
  "edit_basic_info_field_mobile_verify_hint": "修改手机号码请先验证",
  "edit_basic_info_field_mobile_format_error": "手机格式错误",
  "verify_field_mobile_hint": "请输入手机号码",
  "verify_field_mobile_format_error": "手机格式错误",
  "verify_field_mobile_token_hint": "请输入手机验证码",
  "verify_field_agree": "同意",
  "verify_field_privacy_policy": "隐私权政策",
  "verify_field_services": "服务条款",
  "verify_field_and": "及",
  "verify_button_token_send": "发送验证码",
  "verify_alert_agree": "如未同意服务条款及隐私权政策, 将无法继续",
  "verify_alert_token_success": "验证成功",
  "question_select_none": "没有",
  "question_select_seldom": "很少",
  "question_select_sometimes": "有时",
  "question_select_often": "常常",
  "question_select_yes": "是",
  "question_select_no": "否",
  "question_hint_none": "近一个月内没有发生",
  "question_hint_seldom": "近一个月内约3次(含)以下",
  "question_none_sometimes": "近一个月内约10次(含)以下",
  "question_none_often": "近一个月内超过10次",
  "question_button_prev": "上一页",
  "question_button_next": "下一页",
  "question_some_question_not_complete": "部分题目尚未完成",
  "result_subject_basic_info": "基本资料",
  "result_subject_unlucky_info": "坎点",
  "result_subject_constitution": "体质",
  "result_subject_constitution_common_status": "体质常见症状",
  "result_subject_constitution_notice": "温馨提醒",
  "result_subject_lucky_number": "心想事成密码",
  "result_subject_lucky_direction": "开运方位",
  "result_subject_lucky_color": "幸运颜色",
  "result_subject_hid_sick": "潜在疾病",
  "result_subject_mix_constitution": "先后天体质综合分析",
  "result_subject_congenital_constitution": "先天体质",
  "result_subject_most_sick": "最常发生疾病",
  "result_subject_second_sick": "较容易发生疾病",
  "result_subject_bad_food": "忌吃食物",
  "result_subject_good_food": "宜吃食物",
  "result_subject_drink": "茶饮",
  "result_subject_recipe": "食疗",
  "result_subject_acupoint": "穴道",
  "result_subject_exercise": "运动",
  "result_subject_extra_info": "磁場能量站",
  "result_subject_other": "其他",
  "result_subject_recommand": "精选推荐",
  "result_subject_recommand_product": "针对您的体质推荐以下产品",
  "result_unlucky_info_n_year_img": "{0}年坎点图",
  "result_unlucky_info_what": "什么是坎点？",
  "result_unlucky_info_description": "以易经而言，坎点就像是河中的深洞，踩入容易溺毙。\n若以人体的观点来看，每个人在不同时间点的磁场都不一样，有先天的因素也有后天的影响，就好比先天弱脏，特别容易受到内、外环境影响而产生磁场波动。\n楼易健康坎点系统透过五运六气天气医学、个人先后天体质、大数据分析，进而推算出个人当下的磁场变化，当磁场较弱的时候，系统就会将其磁场图画入坎区并标注出坎点，表示这段时间可能会出现健康上的关卡。\n当我们知道坎点的时间区段后，就可以提前注意身体，及早保养调理，达到预防疾病的目的，以安然地度过这段时间。",
  "result_fetch_field": "资料获取失败",
  "result_fetch_retry": "重新尝试",
  "result_share": "分享",
  "result_share_content": "您的朋友做了坎点预测, 一起来测验吧",
  "result_retest": "再次测验",
  "result_retest_time": "下次检测时间 {0}年{1}月{2}日",
  "result_retest_hint": "您有一次重新测验机会",
  "result_you_are_constitution": "您为{0}体质",
  "result_qi_1": "初之气",
  "result_qi_2": "二之气",
  "result_qi_3": "三之气",
  "result_qi_4": "四之气",
  "result_qi_5": "五之气",
  "result_qi_6": "六之气",
  "privacy_policy": "「{0}」是由「楼易健康科技股份有限公司」（下称我们）所经营之网站(下称本网站)各项服务与资讯。 \n          以下是我们的隐私权保护政策，帮助您了解本网站所搜集的个人资料之运用及保护方式。 \n          一、隐私权保护政策的适用范围\n          （1）请您在于使用本网站服务前，确认您已审阅并同意本隐私权政策所列全部条款，若您不同意全部或部份者，则请勿使用本网站服务。 \n          （2）隐私权保护政策内容，包括我们如何处理您在使用本网站服务时搜集到的个人识别资料。 \n          （3）隐私权保护政策不适用于本网站以外的相关连结网站，亦不适用于非我们所委托或参与管理之人员。 \n          二、个人资料的搜集及使用\n          （1）于一般浏览时，伺服器会自行记录相关行径，包括您使用连线设备的IP位址、使用时间、使用的浏览器、浏览及点选资料记录等，做为我们增进服务的参考依据，此记录为内部应用，绝不对外公布。 \n          （2）在使用我们的服务时，我们可能会要求您向我们提供可用于联系或识别您的某些个人资料，包括：\n          • C001辨识个人者： 如姓名、地址、电话、电子邮件等资讯。 •\n          C011个人描述：例如：性别、出生年月日等。 \n          （3）本网站将搜集的数据用于各种目的： •提供和维护系统所提供读服务\n          •提供用户支持 •提供分析或有价值讯息，以便我们改进服务\n          •监控服务的使用情况 •检测，预防和解决技术问题\n          （4）本网站针对搜集数据的利用期间、地区、对象及方式：\n          •期间：当事人要求停止使用或本服务停止提供服务之日为止。 \n          •地区：个人资料将用于台湾地区。 \n          •利用对象及方式：所搜集到的资料将利用于各项业务之执行，利用方式为因业务执行所必须进行之各项分析、联系及通知。 \n          三、资料的保护与安全\n          （1）本网站主机均设有防火墙、防毒系统等相关资讯安全设备及必要的安全防护措施，本网站及您的个人资料均受到严格的保护。只有经过授权的人员才能接触您的个人资料，相关处理人员均有签署保密合约，如有违反保密义务者，将会受到相关的法律处分。 \n          （2）如因业务需要有必要委托本网站相关单位提供服务时，我们会要求其遵守保密义务，并采取相当之检查程序以确定其将确实遵守。 \n          （3）请您妥善保管您的密码与个人资料，并提醒您使用完毕本网站相关服务后，务必关闭本网站，以免您的资料遭人盗用。 \n          （4）您同意在使用本网站服务时，所留存的资料与事实相符。另若嗣后您发现您的个人资料遭他人非法使用或有任何异常时，应即时通知我们。 \n          （5）您同意于使用本网站服务时，所提供及使用之资料皆为合法，并无侵害第三人权利、违反第三方协议或涉及任何违法行为。如因使用本APP服务而致第三人损害，除因我们故意或重大过失所致外，我们并不负担相关赔偿责任。 \n          四、对外的相关连结\n          本网站上有可能包含其他合作网站或网页连结，该网站或网页也有可能会搜集您的个人资料，不论其内容或隐私权政策为何，皆与本网站\n          无关，您应自行参考该连结网站中的隐私权保护政策，我们不负任何连带责任。 \n          五、与第三人共用个人资料之政策\n          （1）本网站绝不会提供、交换、出租或出售任何您的个人资料给其他个人、团体、私人企业或公务机关，但有法律依据或合约义务者，不在此限。 \n          （2）前项但书之情形包括但不限于： •经由您书面同意。 •法律明文规定。 \n          •为维护国家安全或增进公共利益。 \n          •为免除您生命、身体、自由或财产上之危险。 \n          •与公务机关或学术研究机构合作，基于公共利益为统计或学术研究而有必要，且资料经过提供者处理或搜集者依其揭露方式无从识别特定之当事人。 \n          •当您在网站的行为，违反服务条款或可能损害或妨碍网站与其他使用者权益或导致任何人遭受损害时，经网站管理单位研析揭露您的个人资料是为了辨识、联络或采取法律行动所必要者。 \n          •有利于您的权益。 \n          （3）本网站委托厂商协助搜集、处理或利用您的个人资料时，将对委外厂商或个人善尽监督管理之责。 \n          六、Cookie之使用\n          （1）为了提供您最佳的服务，本网站会在您的电脑中放置并取用我们的Cookie，若您不愿接受Cookie的写入，您可在您使用的浏览器功能项中设定隐私权等级为高，即可拒绝Cookie的写入，但可能会导致网站某些功能无法正常执行\n          。以下是可能使用的Cookie范例: •session cookies.\n          用来维护应用程式的状态 •Preference Cookies. 用来记录您的喜好与设定\n          •Security Cookies. 用来控制安全和检查 七、未成年人保护\n          未成年人于注册或使用本服务而同意本公司搜集、利用其个人资讯时，应按其年龄由其法定代理人代为或在法定代理人之同意下为之。 \n          八、隐私权政策的修订\n          我们将因应需求拥有随时修改本隐私权保护政策的权利，当我们做出修改时，会于本网站公告，且自公告日起生效，不再另行通知。 ",
  "services": "          一、会员服务及权利义务\n          1.欢迎您来到「{0}」（以下称「本网站」），本网站由楼易健康科技股份有限公司(以下简称『楼易』)负责经营。 \n          2.本网站主要提供您以下服务： ．商品销售及配送服务 ．活动资讯提供\n          ．会员相关权益通知 本网站得依实际情形，增加、修改或是终止相关服务。 \n          3.加入为楼易网路会员，您还可享有： ．红利点数积点\n          ．红利点数折抵优惠．不定期获得楼易最新资讯、商品快报及好康活动。 \n          4.若您开始使用本网站所提供之客户服务时，即视为已知悉并完全同意本使用条款的所有约定并完全接受本服务的项目，您应自行\n          注意条款变动，本条款之内容如有异动将于本网站公告。如果您不同意修改的内容，应停止继续使用本网站之服务。如果您继续\n          使用本网站服务，则视为您已同意并接受本条款等增订或修改内容之拘束。 \n          5.若您未满二十岁，应于您的法定代理人阅读、了解并同意本约定书之所有内容及其后修改变更后，方得使用或继续使用。当您使\n          用或继续使用本网站，即表示您的法定代理人已阅读、了解并同意接受本约定书之所有内容及其后修改变更。 \n          6.本公司保有更改各项服务内容或终止任一违反法律规定或双方约定之客户帐户服务之权利。此外本公司亦有权于任何时间基于需\n          要修改或变更本条款内容，并将修改内容于本网站公告。 \n          二、客户帐号、密码与安全\n          1.您注册网路会员时必须填写确实资料，若发现有不实之登录，或原所登录资料已不符合真实而未更新，楼易保留随时暂停或终\n          止您网路会员资格及使用各项服务资格之权利。若您冒用他人名义，并造成其他会员或本站之损失，楼易将保留追诉权，并提\n          供相关资料给警调单位调查。 \n          2.为维护您的权益，请妥善保管您的网路会员帐号（以下简称帐号）及密码，且每次连线完毕，均结束您的帐号使用,\n          同时，您应严防个人资料、付款资料（包含信用卡资料）及密码外泄。您的帐号、密码如有遗失或被窃之虑或有其他任何安全问题发生时，\n          应即时通知楼易网路商店并作修改，以免损害您本身权益，以同一个帐号和密码进入后所进行的所有行为，都将被认为是该会\n          员本人的行为，若因您自行泄露帐号及密码所造成之损害及法律责任，楼易网路商店不负连带责任，利用该帐号及密码所进行\n          的一切行动，您将负完全的责任。三、智慧财产权\n          本网站所使用之软体或程式及网站上所有内容除事先经楼易或其权利人之合法授权，任何人不得擅自使用、修改、重制、公开播\n          送等。如有违反，您应对本公司负损害赔偿责任。四、网路会员隐私权保障\n          1.您同意楼易搜集、处理及利用个人资料于楼易业务之特定目的如下：行销业务、客户管理与服务、网路购物业务。 \n          2.本公司对于网路会员所登录或留存之个人资料，除楼易搜集、处理及利用个人资料之特定目的外，除下列情形，绝不揭露网路\n          会员之姓名、地址、信用卡卡号、电子邮件地址及其他依法受保护之个人资料。 \n          ※ 依法令规定、或依司法机关或其他有权机关的命令。 \n          ※为执行本约定条款、或使用者违反约定条款。 \n          ※为维护楼易网路商店系统之正常运作及安全。 ※ 经当事人书面同意。 \n          3.您同意接受楼易之「隐私权保障」，楼易将尽力以合理之技术及程序，保障所有个人资料之安全。 \n          五、暂停服务\n          1.本公司以目前一般认为合理之方式及技术，维护本服务之正常运作。但在下列情况之下，本公司将暂停或中断本服务之全部或一\n          部分，因之对使用者所致任何直接或间接之影响，不负任何赔偿或补偿责任：\n          1-1.对本服务相关软体设备进行搬迁、更换、升级、保养或维修。 \n          1-2.使用者有任何违反政府法令或本使用条款情形。 \n          1-3.天灾或其他不可抗力之因素所导致之服务中断或停止。 \n          1-4.其他不可归责于本公司之事由所致之服务中断或停止。 \n          1-5.非本公司所能控制之事由而致本服务资讯显示不正确、或遭伪造、窜改、删除或撷取、或致系统中断或不能正常运作时。 \n          2.本公司针对可预知之软硬体维护工作，有可能导致系统中断或是暂停者，将会于该状况发生之前，以适当方式告知网路会员。 \n          六、本条款之效力 . 本条款所定一部分无效时，不影响其他部份之效力。 "
}